import { cn } from "../lib/utils";
import { cva } from "class-variance-authority";
import * as React from "react";
export const COUNTER_SIZES = ["xs", "sm", "md"];
const counterVariants = cva("inline-flex items-center justify-center rounded-md tabular-nums", {
    variants: {
        size: {
            xs: "h-4 min-w-4 px-1 heading-xs",
            sm: "h-5 min-w-5 px-1 heading-sm",
            md: "h-6 min-w-6 px-1.5 heading-base",
        },
        variant: {
            primary: "",
            highlight: "",
            "highlight-secondary": "",
            warning: "",
            "warning-secondary": "",
            info: "",
            outline: "",
            ghost: "",
            "ghost-secondary": "",
        },
        isInButton: {
            true: "",
            false: "",
        },
    },
    compoundVariants: [
        {
            isInButton: false,
            variant: "primary",
            className: "bg-primary-800 text-primary-50",
        },
        {
            isInButton: false,
            variant: ["highlight", "highlight-secondary"],
            className: "bg-highlight-500 text-white",
        },
        {
            isInButton: false,
            variant: ["warning", "warning-secondary"],
            className: "bg-warning-500 text-white",
        },
        {
            isInButton: false,
            variant: "info",
            className: "bg-info-500 text-white",
        },
        {
            isInButton: false,
            variant: "outline",
            className: "bg-muted text-muted-foreground border border-border",
        },
        {
            isInButton: false,
            variant: ["ghost", "ghost-secondary"],
            className: "text-muted-foreground",
        },
        {
            isInButton: true,
            variant: "primary",
            className: "bg-highlight-400 text-white",
        },
        {
            isInButton: true,
            variant: ["highlight", "highlight-secondary"],
            className: "bg-highlight-400 text-white",
        },
        {
            isInButton: true,
            variant: ["warning", "warning-secondary"],
            className: "bg-warning-400 text-white",
        },
        {
            isInButton: true,
            variant: "info",
            className: "bg-info-400 text-white",
        },
        {
            isInButton: true,
            variant: "outline",
            className: "bg-primary-150 text-primary-700",
        },
        {
            isInButton: true,
            variant: ["ghost", "ghost-secondary"],
            className: "bg-primary-150 text-primary-700",
        },
    ],
    defaultVariants: {
        size: "sm",
        variant: "primary",
        isInButton: false,
    },
});
export const Counter = React.forwardRef(({ value, className, size = "sm", variant = "primary", isInButton = false, ...props }, ref) => {
    return (React.createElement("div", { ref: ref, className: cn(counterVariants({ size, variant, isInButton }), className), ...props }, value));
});
Counter.displayName = "Counter";
//# sourceMappingURL=Counter.js.map